// Offset/limit pager for the monitoring lists. Shows "X–Y of N" + prev/next; hidden when a single page.
export function Pagination({
  total,
  limit,
  offset,
  onChange,
}: {
  total: number
  limit: number
  offset: number
  onChange: (offset: number) => void
}) {
  if (total <= limit && offset === 0) return null
  const from = total === 0 ? 0 : offset + 1
  const to = Math.min(offset + limit, total)
  const canPrev = offset > 0
  const canNext = offset + limit < total
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
      <span className="muted" style={{ fontSize: 12 }}>
        {from}–{to} of {total}
      </span>
      <div style={{ display: 'flex', gap: 6 }}>
        <button className="btn sm ghost" disabled={!canPrev} onClick={() => onChange(Math.max(0, offset - limit))}>
          Prev
        </button>
        <button className="btn sm ghost" disabled={!canNext} onClick={() => onChange(offset + limit)}>
          Next
        </button>
      </div>
    </div>
  )
}
